import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import RateReviewIcon from "@mui/icons-material/RateReview";
import { useTranslation } from "react-i18next";
import { getTextByLanguage } from "../api/text";

const CustomPageContent = ({ contenidoIntermedio, eventData, businessData, onNavigateToRatings }) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language || "es";

  // Obtener estilos del contenido intermedio
  const estilos = contenidoIntermedio?.estilos || {};
  const containerStyle = {
    backgroundColor: estilos.colorFondo || undefined,
    color: estilos.colorTexto || undefined,
    fontFamily: estilos.fuente || undefined,
    padding: estilos.espaciado ? `${estilos.espaciado}px` : undefined,
  };
  const primaryColor = estilos.colorPrimario || "#1976d2";

  // Obtener contenido traducido
  const getContent = () => {
    const contenido = contenidoIntermedio?.configuracion?.contenido || {};
    if (typeof contenido === "string") return contenido;
    return contenido[currentLang] || contenido["es"] || Object.values(contenido)[0] || "";
  };

  const content = getContent();

  return (
    <Container maxWidth="md" style={{ marginTop: "20px", marginBottom: "40px", ...containerStyle }}>
      <Paper style={{ 
        padding: "2rem", 
        marginBottom: "20px",
        backgroundColor: estilos.colorFondo || undefined,
        color: estilos.colorTexto || undefined,
      }}>
        {content ? (
          <div
            dangerouslySetInnerHTML={{ __html: content }}
            style={{
              lineHeight: "1.6",
              fontSize: "16px",
              color: estilos.colorTexto || undefined,
            }}
          />
        ) : (
          <Typography 
            variant="body1" 
            style={{ 
              textAlign: "center", 
              padding: "40px",
              color: estilos.colorTexto ? "rgba(0, 0, 0, 0.6)" : undefined,
            }}
          >
            {t("event.customPage.noContent")}
          </Typography>
        )}
      </Paper>

      {/* Botón para ir a ratings */}
      {(() => {
        const botonRatings = contenidoIntermedio?.botonRatings || {};
        const posicion = botonRatings.posicion || "abajo";
        const estilo = botonRatings.estilo || {};
        
        // Obtener texto del botón
        const getButtonText = () => {
          const textoBoton = botonRatings.texto || {};
          if (typeof textoBoton === "string") return textoBoton;
          return textoBoton[currentLang] || textoBoton["es"] || Object.values(textoBoton)[0] || t("event.customPage.rate");
        };
        
        const textoBoton = getButtonText();
        const icono = estilo.icono || "";
        
        // Determinar tamaño del botón
        const getButtonSize = () => {
          switch (estilo.tamano) {
            case "pequeno":
              return { padding: "8px 20px", fontSize: "14px" };
            case "grande":
              return { padding: "16px 50px", fontSize: "20px" };
            case "muy-grande":
              return { padding: "20px 60px", fontSize: "24px" };
            default:
              return { padding: "12px 40px", fontSize: "18px" };
          }
        };

        const buttonSize = getButtonSize();
        const buttonStyle = {
          ...buttonSize,
          backgroundColor: estilo.colorFondo || primaryColor,
          color: estilo.colorTexto || "#ffffff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          margin: "0 auto",
        };

        // Estilos según posición
        const containerStyle = {
          marginTop: posicion === "arriba" ? "0" : "40px",
          marginBottom: posicion === "arriba" ? "40px" : "0",
          textAlign: "center",
        };

        // Si es flotante, aplicar estilos especiales
        if (posicion === "flotante") {
          return (
            <Box
              style={{
                position: "fixed",
                bottom: "calc(20px + var(--cookie-bar-h, 0px))",
                right: "20px",
                zIndex: 1000,
              }}
            >
              <button onClick={onNavigateToRatings} style={buttonStyle}>
                <RateReviewIcon style={{ fontSize: "20px", marginRight: "4px" }} />
                {textoBoton}
              </button>
            </Box>
          );
        }

        return (
          <Box style={containerStyle}>
            <button onClick={onNavigateToRatings} style={buttonStyle}>
              <RateReviewIcon style={{ fontSize: "20px", marginRight: "4px" }} />
              {textoBoton}
            </button>
          </Box>
        );
      })()}
    </Container>
  );
};

export default CustomPageContent;

